{
  "$schema": "http://json.schemastore.org/package",
  "name": "verdaccio-oidc-auth",
  "version": "6.0.2",
  "keywords": [
    "authentication",
    "github",
    "login",
    "npm",
    "oauth",
    "package",
    "private",
    "registry",
    "verdaccio",
    "verdaccio-auth",
    "verdaccio-auth-plugin",
    "verdaccio-plugin"
  ],
  "homepage": "https://github.com/n4bb12/verdaccio-github-oauth-ui/blob/master/README.md",
  "bugs": "https://github.com/n4bb12/verdaccio-github-oauth-ui/issues",
  "repository": "github:n4bb12/verdaccio-github-oauth-ui",
  "license": "MIT",
  "author": "Abraham Schilling",
  "main": "dist/server/index.js",
  "bin": "dist/cli/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "bash run build",
    "clean": "bash run clean",
    "cli:login": "bash run cli-login",
    "cli:publish": "bash run cli-publish",
    "cli:whoami": "bash run cli-whoami",
    "cli": "bash run cli",
    "copy": "bash run copy",
    "coverage": "vitest --coverage",
    "dev": "yarn update && yarn start",
    "docker": "bash run docker_",
    "fix": "yarn format && yarn typecheck",
    "format:check": "prettier --check \"**/*.{ts,js,css,scss,html,json}\"",
    "format": "prettier --write \"**/*.{ts,js,css,scss,html,json}\"",
    "prepack": "bash run clean && bash run build",
    "start": "verdaccio -c verdaccio.yaml",
    "test": "vitest --watch false",
    "typecheck": "bash run typecheck",
    "update": "yarn prepack && yarn copy",
    "watch": "nodemon --watch src --watch verdaccio.yaml --ext ts,css,yaml --exec \"yarn dev\""
  },
  "dependencies": {
    "@octokit/oauth-methods": "^2.0.5",
    "@octokit/request": "^6.2.3",
    "@verdaccio/url": "^11.0.0-6-next.34",
    "dotenv": "^16.0.3",
    "express": "^4.18.2",
    "global-agent": "^3.0.0",
    "lodash": "^4.17.21",
    "memory-cache": "^0.2.0",
    "minimist": "^1.2.8",
    "octokit": "^2.0.14",
    "open": "^8.4.2",
    "openid-client": "^5.4.2",
    "ow": "^0.28.2",
    "picocolors": "^1.0.0"
  },
  "devDependencies": {
    "@parcel/config-default": "~2.4.1",
    "@parcel/transformer-typescript-tsc": "~2.4.1",
    "@types/express": "^4.17.17",
    "@types/global-agent": "^2.1.1",
    "@types/lodash": "^4.14.194",
    "@types/memory-cache": "^0.2.2",
    "@types/minimist": "^1.2.2",
    "@types/node": "^16.18.24",
    "@verdaccio/types": "^10.8.0",
    "browserslist": "^4.21.5",
    "c8": "^7.13.0",
    "core-js": "^3.30.1",
    "nodemon": "^2.0.22",
    "parcel": "~2.4.1",
    "parcel-plugin-static-files-copy": "^2.6.0",
    "parcel-reporter-static-files-copy": "^1.5.0",
    "prettier": "^2.8.7",
    "process": "^0.11.10",
    "release-it": "^15.10.1",
    "timekeeper": "^2.2.0",
    "type-fest": "^3.8.0",
    "typescript": "^5.0.4",
    "verdaccio": "^5.24.0",
    "verdaccio-htpasswd": "^10.5.5",
    "vite": "^4.3.1",
    "vitest": "^0.30.1"
  },
  "peerDependencies": {
    "verdaccio": ">=5"
  },
  "engines": {
    "node": "^16"
  },
  "publishConfig": {
    "registry": "https://registry.npmjs.org/"
  },
  "targets": {
    "client": {
      "source": "src/client/verdaccio-5.ts",
      "distDir": "dist/client",
      "context": "browser",
      "includeNodeModules": true
    },
    "server": {
      "source": "src/server/index.ts",
      "distDir": "dist/server",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false,
      "isLibrary": true
    },
    "cli": {
      "source": "src/cli/index.ts",
      "distDir": "dist/cli",
      "context": "node",
      "outputFormat": "commonjs",
      "optimize": false
    }
  },
  "staticFiles": {
    "staticPath": "static"
  },
  "packageManager": "yarn@3.2.1"
}
